import { Alert, AlertTitle, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid2";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const BrandConfigurationReportHead = () => {
  return (
    <>
      <Box sx={{ padding: "12px 12px 10px  12px" }}>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid size={7}>
            <Typography variant="h3" sx={{ fontSize: "24px", mb: "5px" }}>
              Brand Configuration
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "14px" }}>
              Track Each Brand’s Integration Progress and Resolve Configuration
              Bottlenecks to Ensure Smooth Data Flow.
            </Typography>

            <Alert
              severity="info"
              icon={
                <InfoOutlinedIcon
                  sx={{ color: "rgba(2, 136, 209, 1)" }}
                  fontSize="inherit"
                />
              }
              sx={{
                border: "none",
                color: "rgba(2, 136, 209, 1)",
                padding: "0px",
                background: "none",
                mt: "5px",
              }}
            >
              <AlertTitle>
                Please note: Integration Status filter is set to “Not Ready”.
              </AlertTitle>
            </Alert>
          </Grid>
          <Grid
            size={5}
            container
            spacing={1}
            flexDirection={"row"}
            justifyContent={"flex-end"}
          ></Grid>
        </Grid>
      </Box>
    </>
  );
};

export default BrandConfigurationReportHead;
